import { default as _91_46_46_46slug_93Tvy8GEdAiMMeta } from "/data/www/westerduin.nl/westerduin/releases/14/nuxt/pages/[...slug].vue?macro=true";
import { default as _4045uYjmxHW3QMeta } from "/data/www/westerduin.nl/westerduin/releases/14/nuxt/pages/404.vue?macro=true";
import { default as indexb1uoo6TleLMeta } from "/data/www/westerduin.nl/westerduin/releases/14/nuxt/pages/arbochecklist/index.vue?macro=true";
import { default as bedanktnr5ffEYYq6Meta } from "/data/www/westerduin.nl/westerduin/releases/14/nuxt/pages/bedankt.vue?macro=true";
import { default as _91slug_93peg3zkwSQhMeta } from "/data/www/westerduin.nl/westerduin/releases/14/nuxt/pages/contact/[slug].vue?macro=true";
import { default as indexsBqjjYmypGMeta } from "/data/www/westerduin.nl/westerduin/releases/14/nuxt/pages/contact/index.vue?macro=true";
import { default as indexhnRepcclWkMeta } from "/data/www/westerduin.nl/westerduin/releases/14/nuxt/pages/index.vue?macro=true";
import { default as _91slug_93YLgQtnljbLMeta } from "/data/www/westerduin.nl/westerduin/releases/14/nuxt/pages/nieuws/[slug].vue?macro=true";
import { default as indexyXYq1srRKkMeta } from "/data/www/westerduin.nl/westerduin/releases/14/nuxt/pages/nieuws/index.vue?macro=true";
import { default as open_45sollicitatieaxF2J4Lsh8Meta } from "/data/www/westerduin.nl/westerduin/releases/14/nuxt/pages/open-sollicitatie.vue?macro=true";
import { default as _91_46_46_46slug_9338cUOLtFGkMeta } from "/data/www/westerduin.nl/westerduin/releases/14/nuxt/pages/over-westerduin/[...slug].vue?macro=true";
import { default as _91slug_93ivMFR5UjueMeta } from "/data/www/westerduin.nl/westerduin/releases/14/nuxt/pages/referenties/[slug].vue?macro=true";
import { default as indexoFAOhfWkCfMeta } from "/data/www/westerduin.nl/westerduin/releases/14/nuxt/pages/referenties/index.vue?macro=true";
import { default as vacatures_45als_45_91slug_93q4lxGux2MaMeta } from "/data/www/westerduin.nl/westerduin/releases/14/nuxt/pages/vacatures-als-[slug].vue?macro=true";
import { default as vacatures_45bij_45_91slug_93PN8UPWpZ2vMeta } from "/data/www/westerduin.nl/westerduin/releases/14/nuxt/pages/vacatures-bij-[slug].vue?macro=true";
import { default as vacatures_45in_45_91slug_93DHccnQEr4VMeta } from "/data/www/westerduin.nl/westerduin/releases/14/nuxt/pages/vacatures-in-[slug].vue?macro=true";
import { default as _91slug_93iNejLgfpeyMeta } from "/data/www/westerduin.nl/westerduin/releases/14/nuxt/pages/vacatures/[slug].vue?macro=true";
import { default as indexVbLIWLDWd4Meta } from "/data/www/westerduin.nl/westerduin/releases/14/nuxt/pages/vacatures/index.vue?macro=true";
import { default as vragenzIJu1jhFw2Meta } from "/data/www/westerduin.nl/westerduin/releases/14/nuxt/pages/vragen.vue?macro=true";
import { default as _91_46_46_46slug_93PHNckFz16hMeta } from "/data/www/westerduin.nl/westerduin/releases/14/nuxt/pages/werkgevers/[...slug].vue?macro=true";
import { default as bedankt5WuFOrPVpvMeta } from "/data/www/westerduin.nl/westerduin/releases/14/nuxt/pages/werkgevers/bedankt.vue?macro=true";
import { default as faq0FcbJ36S1TMeta } from "/data/www/westerduin.nl/westerduin/releases/14/nuxt/pages/werkgevers/faq.vue?macro=true";
import { default as registratie_45inlenersbeloningt2QsfwAdFgMeta } from "/data/www/westerduin.nl/westerduin/releases/14/nuxt/pages/werkgevers/registratie-inlenersbeloning.vue?macro=true";
import { default as werkwijze5jQNWaf1EyMeta } from "/data/www/westerduin.nl/westerduin/releases/14/nuxt/pages/werkwijze.vue?macro=true";
export default [
  {
    name: "slug",
    path: "/:slug(.*)*",
    meta: _91_46_46_46slug_93Tvy8GEdAiMMeta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/14/nuxt/pages/[...slug].vue").then(m => m.default || m)
  },
  {
    name: "404",
    path: "/404",
    component: () => import("/data/www/westerduin.nl/westerduin/releases/14/nuxt/pages/404.vue").then(m => m.default || m)
  },
  {
    name: "arbochecklist",
    path: "/arbochecklist",
    meta: indexb1uoo6TleLMeta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/14/nuxt/pages/arbochecklist/index.vue").then(m => m.default || m)
  },
  {
    name: "bedankt",
    path: "/bedankt",
    meta: bedanktnr5ffEYYq6Meta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/14/nuxt/pages/bedankt.vue").then(m => m.default || m)
  },
  {
    name: "contact-slug",
    path: "/contact/:slug()",
    meta: _91slug_93peg3zkwSQhMeta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/14/nuxt/pages/contact/[slug].vue").then(m => m.default || m)
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexsBqjjYmypGMeta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/14/nuxt/pages/contact/index.vue").then(m => m.default || m)
  },
  {
    name: "index",
    path: "/",
    meta: indexhnRepcclWkMeta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/14/nuxt/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "nieuws-slug",
    path: "/nieuws/:slug()",
    meta: _91slug_93YLgQtnljbLMeta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/14/nuxt/pages/nieuws/[slug].vue").then(m => m.default || m)
  },
  {
    name: "nieuws",
    path: "/nieuws",
    meta: indexyXYq1srRKkMeta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/14/nuxt/pages/nieuws/index.vue").then(m => m.default || m)
  },
  {
    name: "open-sollicitatie",
    path: "/open-sollicitatie",
    meta: open_45sollicitatieaxF2J4Lsh8Meta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/14/nuxt/pages/open-sollicitatie.vue").then(m => m.default || m)
  },
  {
    name: "over-westerduin-slug",
    path: "/over-westerduin/:slug(.*)*",
    meta: _91_46_46_46slug_9338cUOLtFGkMeta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/14/nuxt/pages/over-westerduin/[...slug].vue").then(m => m.default || m)
  },
  {
    name: "referenties-slug",
    path: "/referenties/:slug()",
    component: () => import("/data/www/westerduin.nl/westerduin/releases/14/nuxt/pages/referenties/[slug].vue").then(m => m.default || m)
  },
  {
    name: "referenties",
    path: "/referenties",
    meta: indexoFAOhfWkCfMeta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/14/nuxt/pages/referenties/index.vue").then(m => m.default || m)
  },
  {
    name: "vacatures-als-slug",
    path: "/vacatures-als-:slug()",
    meta: vacatures_45als_45_91slug_93q4lxGux2MaMeta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/14/nuxt/pages/vacatures-als-[slug].vue").then(m => m.default || m)
  },
  {
    name: "vacatures-bij-slug",
    path: "/vacatures-bij-:slug()",
    meta: vacatures_45bij_45_91slug_93PN8UPWpZ2vMeta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/14/nuxt/pages/vacatures-bij-[slug].vue").then(m => m.default || m)
  },
  {
    name: "vacatures-in-slug",
    path: "/vacatures-in-:slug()",
    meta: vacatures_45in_45_91slug_93DHccnQEr4VMeta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/14/nuxt/pages/vacatures-in-[slug].vue").then(m => m.default || m)
  },
  {
    name: "vacatures-slug",
    path: "/vacatures/:slug()",
    meta: _91slug_93iNejLgfpeyMeta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/14/nuxt/pages/vacatures/[slug].vue").then(m => m.default || m)
  },
  {
    name: "vacatures",
    path: "/vacatures",
    meta: indexVbLIWLDWd4Meta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/14/nuxt/pages/vacatures/index.vue").then(m => m.default || m)
  },
  {
    name: "vragen",
    path: "/vragen",
    meta: vragenzIJu1jhFw2Meta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/14/nuxt/pages/vragen.vue").then(m => m.default || m)
  },
  {
    name: "werkgevers-slug",
    path: "/werkgevers/:slug(.*)*",
    meta: _91_46_46_46slug_93PHNckFz16hMeta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/14/nuxt/pages/werkgevers/[...slug].vue").then(m => m.default || m)
  },
  {
    name: "werkgevers-bedankt",
    path: "/werkgevers/bedankt",
    component: () => import("/data/www/westerduin.nl/westerduin/releases/14/nuxt/pages/werkgevers/bedankt.vue").then(m => m.default || m)
  },
  {
    name: "werkgevers-faq",
    path: "/werkgevers/faq",
    meta: faq0FcbJ36S1TMeta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/14/nuxt/pages/werkgevers/faq.vue").then(m => m.default || m)
  },
  {
    name: "werkgevers-registratie-inlenersbeloning",
    path: "/werkgevers/registratie-inlenersbeloning",
    component: () => import("/data/www/westerduin.nl/westerduin/releases/14/nuxt/pages/werkgevers/registratie-inlenersbeloning.vue").then(m => m.default || m)
  },
  {
    name: "werkwijze",
    path: "/werkwijze",
    component: () => import("/data/www/westerduin.nl/westerduin/releases/14/nuxt/pages/werkwijze.vue").then(m => m.default || m)
  }
]